<template>
  <div class="audio-container">
    <img v-if="coverurl" :src="coverurl" class="cover-img" />
    <img v-else src="~assets/images/audio.png" class="cover-img" />
    <audio @timeupdate="updateProgress" controls ref="audioRef" style="display: none" :src="fileurl">
      <!-- <source :src="fileurl" type="audio/mpeg" /> -->
      您的浏览器不支持音频播放
    </audio>
    <div class="audio-right">
      <Icon v-if="audioStatus === 'play'" type="md-play" class="dialogAudioPlay" @click="playAudio"></Icon>
      <Icon v-else type="md-pause" class="dialogAudioPlay" @click="playAudio"></Icon>
      <div class="progress-bar-bg" :id="progressBarBg">
        <div class="progress-bar" :id="progressBar"></div>
      </div>
      <div class="audio-time" style="min-height: 10px">
        <span class="audio-length-current" :id="audioCurTime">{{ audioStart }}</span
        >/
        <span class="audio-length-total">{{ duration }}</span>
      </div>
      <div class="volume">
        <div
          @click.stop="
            () => {
              return false
            }
          "
          class="volume-progress"
          v-show="audioHuds"
        >
          <div class="volume-bar-bg" id="volumeBarBg" v-adjuster="handleShowMuteIcon">
            <div class="volume-bar" id="volumeBar"></div>
          </div>
        </div>
        <i class="iconfont pl-1" :class="audioIcon" @click.stop="audioHuds = !audioHuds"> </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileurl: {
      trpe: String
    },
    id: {
      type: Number,
      default: 0
    },
    coverurl: {
      type: String
    }
  },
  data() {
    return {
      audioStart: '0:00',
      duration: '0:00',
      audioVolume: 0.5,
      audioHuds: false,
      audioStatus: 'play',
      tha: this
    }
  },
  directives: {
    dragto: {
      inserted: function (el, binding, vnode) {
        el.addEventListener(
          'click',
          (e) => {
            const wdiv = document.getElementById(vnode.data.attrs.id).clientWidth
            const audio = vnode.context.$refs.audioRef
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            const ratemin = e.offsetX / wdiv
            const rate = ratemin * 100
            document.getElementById(vnode.data.attrs.id).style.width = rate + '%'
            audio.currentTime = audio.duration * ratemin
            audio.play()
            binding.value()
          },
          false
        )
      }
    },
    adjuster: {
      inserted: function (el, binding, vnode) {
        el.addEventListener(
          'click',
          (e) => {
            const hdiv = document.getElementById('volumeBarBg').clientHeight
            const audio = vnode.context.$refs.audioRef
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            const ratemin = e.offsetY / hdiv
            const rate = ratemin * 100
            document.getElementById('volumeBar').style.height = rate + '%'
            audio.volume = ratemin
            binding.value(rate / 100)
          },
          false
        )
      }
    }
  },
  computed: {
    audioIcon() {
      if (this.audioHuds) {
        return this.audioVolume < 0.01 ? 'checked icon-jingyin' : 'checked icon-shengyin'
      } else {
        return 'icon-shengyin'
      }
    },
    progressBarBg() {
      return `progressBarBg${this.id}`
    },
    progressBar() {
      return 'progressBar' + this.id
    },
    audioCurTime() {
      return `audioCurTime${this.id}`
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      const that = this
      var myVid = this.$refs.audioRef
      myVid.loop = false
      // 监听音频播放完毕
      myVid.addEventListener(
        'ended',
        function () {
          that.audioStatus = 'play' // 显示播放icon
          document.getElementById(that.progressBar).style.width = '0%' // 进度条初始化
        },
        false
      )
      if (myVid != null) {
        myVid.oncanplay = function () {
          that.duration = that.transTime(myVid.duration) // 计算音频时长
        }
        myVid.volume = 0.5 // 设置音量50%
      }
    },
    // 播放暂停控制
    playAudio() {
      const recordAudio = this.$refs.audioRef // 获取audio元素
      if (recordAudio.paused) {
        recordAudio.play()
        this.audioStatus = 'pause'
      } else {
        recordAudio.pause()
        this.audioStatus = 'play'
      }
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration
      if (document.getElementById(this.progressBar)) {
        document.getElementById(this.progressBar).style.width = value * 100 + '%'
        if (e.target.currentTime === e.target.duration) {
          this.audioStatus = 'pause'
        }
      } else {
        this.audioStatus = 'pause'
      }

      this.audioStart = this.transTime(this.$refs.audioRef.currentTime)
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(time) {
      var duration = parseInt(time)
      var minute = parseInt(duration / 60)
      var sec = (duration % 60) + ''
      var isM0 = ':'
      if (minute === 0) {
        minute = '00'
      } else if (minute < 10) {
        minute = '0' + minute
      }
      if (sec.length === 1) {
        sec = '0' + sec
      }
      return minute + isM0 + sec
    },
    // setAudioIcon () {
    //   this.audioStatus = 'pause'
    // },
    handleShowMuteIcon(val) {
      this.audioVolume = val
    }
  }
}
</script>

<style lang="scss" scoped>
.audio-container {
  display: flex;
  justify-content: center;

  &:hover {
    .audio-right {
      opacity: 1;
    }
  }
}

.cover-img {
  height: 100%;
}

.volume {
  position: relative;

  .volume-progress {
    position: absolute;
    top: -150px;
    width: 32px;
    height: 140px;
    background: #f6f6f6;
    padding-top: 10px;
  }

  .volume-bar-bg {
    margin: 0 auto;
    width: 6px;
    height: 120px;
    background: #dcdcdc;
    border-radius: 100px;
    flex: 1;
    position: relative;
    transform: rotate(180deg);
    cursor: pointer;

    .volume-bar {
      width: 6px;
      height: 50%;
      background: #56bf8b;
      border-radius: 100px;
    }
  }

  .checked {
    color: #56bf8b;
  }
}

.audio-right {
  width: 100%;
  height: 49px;
  line-height: 49px;
  display: flex;
  padding: 0 15px;
  bottom: 0;
  position: absolute;
  opacity: 0;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));

  .dialogAudioPlay {
    cursor: pointer;
    color: #fff;
    font-size: 20px;
    padding: 13px 0;
  }

  .progress-bar-bg {
    background-color: #acacac;
    flex: 1;
    position: relative;
    height: 4px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -1px;
    cursor: pointer;
    margin: 0 10px;
  }

  .progress-bar {
    background-color: #fff;
    width: 0%;
    height: 4px;
  }

  .audio-time {
    overflow: hidden;
    font-size: 14px;
    color: #fff;

    .audio-length-total {
      float: right;
    }

    .audio-length-current {
      float: left;
    }
  }
}
</style>
